import { sendRequest } from "../ajax/ajax_es";

export function initGridSort()
{
    const buttons = document.getElementsByClassName('grid-sort-button');
    const grid = document.getElementById('product-grid');

    for (let i = 0; i < buttons.length; i++) {
        let button = buttons[i];
        let link = button.getAttribute('data-link');

        button.addEventListener('click', () => {
            gridSort(button, link, grid);
        });
    }
}

function gridSort(button, link, grid) {
    const regex = /productCardGrid-order=([^&]+)/;
    const match = link.match(regex);
    const order = match ? match[1] : null;
    const isOrderActive = button.classList.contains('active');

    const content = grid.getElementsByClassName('next-data-ph')[0];
    content.setAttribute('data-order', order);
    content.setAttribute('data-col', 'price');

    sendRequest(link, function (xmlhttp) {
        const snippetResponse = xmlhttp.response;
        const snippet = Object.values(snippetResponse.snippets)[0];
        const dataBlock = grid.querySelector('.product-card-grid');

        dataBlock.innerHTML = snippet;

        if (!isOrderActive) {
            handleButtonSortBehaviour();
        }
    });
}

function handleButtonSortBehaviour() {
    const buttons = document.getElementsByClassName('grid-sort-button');

    Array.prototype.forEach.call(buttons, function(button) {
        button.classList.toggle('active');
    });
}